// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { SchemaForm, Input, Row, Col } from "@components";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  formRef: *,
  data: Object,
  schema: Object,
  onChange: (a: Object) => void,
  onSubmit: (a: Object) => void,
  editing: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AbsenceMonitoringSettingsForm extends React.Component<Props> {
  render() {
    return (
      <div className="w-100 d-flex justify-content-center gs-container">
        <div className="col-sm-12">
          {this.props.editing && this.props.data ? (
            <Row className="p-2">
              <Col className="d-flex flex-column flex-end p-0 pb-2">
                <label htmlFor="titleId" className="mr-3">
                  {this.props.t("ABSENCE_MONITORING_PROCESS_ID_TITLE")}:
                </label>
                <div className="w-100">
                  <Input id="titleId" readOnly value={this.props.data.id} />
                </div>
              </Col>
            </Row>
          ) : null}
          {this.props.data ? (
            <SchemaForm
              ref={this.props.formRef}
              className="w-100"
              formData={this.props.data}
              schema={this.props.schema}
              onChange={this.props.onChange}
              onSubmit={this.props.onSubmit}
              uiSchema={uiSchema(this.props.t, this.props.data)}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          ) : null}
        </div>
      </div>
    );
  }
}

export default localize()(AbsenceMonitoringSettingsForm);
